import { api } from '../../App'
import { createNotification } from '../../components/Notifications/Notifications'
import { SET_PERSONNEL_LOADING } from '../types'

// Бэк возвращает detail строкой ("минимум 8 символов; ...") либо массивом причин
// (строк или объектов { msg }) — приводим к одной читаемой строке.
const getPasswordErrorMessage = (ERR, fallback) => {
  const detail = ERR?.response?.data?.detail
  if (Array.isArray(detail)) {
    const reasons = detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean)
    return reasons.length ? reasons.join('; ') : fallback
  }
  return detail || fallback
}

export const changePersonnelPassword = (mid, data) => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true })
    const response = await api.post(`/personnel_structure/${mid}/change-password`, data)
    const message = response.data.message || 'Пароль успешно изменён'
    createNotification('success', message)
    return { success: true, message }
  } catch (ERR) {
    console.log(ERR)
    const message = getPasswordErrorMessage(ERR, 'Ошибка при смене пароля')
    createNotification('error', message)
    return { success: false, message }
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false })
  }
}
